import { render, staticRenderFns } from "./license.vue?vue&type=template&id=80c2faee&scoped=true"
import script from "./license.vue?vue&type=script&lang=js"
export * from "./license.vue?vue&type=script&lang=js"
import style0 from "./license.vue?vue&type=style&index=0&id=80c2faee&prod&scoped=true&lang=css"
import style1 from "./license.vue?vue&type=style&index=1&id=80c2faee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c2faee",
  null
  
)

export default component.exports